import { gql } from "@apollo/client";

export const getLensActivityTotals = gql`
    query lensActivityTotals($input: LensActivityTotalsInput!) {
        lensActivityTotals(input: $input) {
            lenses {
                unlockableId
                lens {
                    id
                    name
                    iconUrl
                    organizationId
                    lensAccountId {
                        lensSpaceId
                    }
                }
                totals {
                    lensScore
                    subscriberActionsUu
                    subscribeCount
                }
                paidAmountMilliUsd
            }
            creatorTotals {
                lensScore
                subscriberActionsUu
                subscribeCount
            }
            paidAmountMilliUsd
            cursor
        }
    }
`;
